(function() {
    'use strict';

    angular.module("imApp").factory("shiftPlansService", ['$ihttp', function ($ihttp) {
        let service = {
            listShiftPLans: function (parms) {
                return $ihttp.post({
                    method: 512,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
